import React from 'react';
import AccordionComponent from '../../../../../../../../Common/CommonComponents/Accordion/accordionComponent';
import SelectedContactComponent from '../selectedContactComponent';
import { getLocalizedStrings } from '../../../../notificationLocalizedStrings';
import GlobalErrorBlock from '../../../../../../../../Common/CommonComponents/GlobalErrorBlock/globalErrorBlock';
import classes from './cppAccordionComponent.scss';
import SetUpVoiceDropdown from '../voiceDropDown';
import SetUpEmailDropdown from '../emailDropdown';
import SetUpTextDropdown from '../textDropdown';

class CPPAccordionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings('dialogBox');
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';

    }
    render() {
        const contactType = this.props.contactType;
        const accordianToggleStatus = this.props.stateData.accordianToggleStatus[contactType];
        return (
            <div className={classes.cppAccordionComponent}>
                <React.Fragment>
                    <div>
                        {this.props.stateData.addContactLimitArr[contactType] > 0 ?
                        <div className={classes.Fragment}>
                            <SelectedContactComponent
                                contactType={contactType}
                                contactMethodIndex={0}
                                dropdownDiffererentiator={'One'}
                                onDoneEnabledButton={this.props.onDoneEnabledButton}
                                addContactValueArr={this.props.stateData.addContactValueArr}
                                addContactEncValueArr={this.props.stateData.addContactEncValueArr}
                                onContactMethodCheckHandler={this.props.onContactMethodCheckHandler}
                                addContactCheckedStatusArr={this.props.stateData.addContactCheckedStatusArr}
                                onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                index={this.props.selectedServiceAccount}
                                reloadManageAlertPref={this.props.reloadManageAlertPref}
                                data={this.props.stateData.preferenceData}
                                onSelectDropDown={this.props.onSelectDropDown}
                                showGloabalError={this.props.showGloabalError}
                                showLoadingSpinner={this.props.showLoadingSpinner}
                                hideLoadingSpinner={this.props.hideLoadingSpinner}
                                isDropDownSelectError={this.props.stateData.isDropDownSelectError}
                                isSameValueSelectError={this.props.stateData.isSameValueSelectError}
                                dropDownData={this.props.dropDownData}
                            />
                            {/* <div className={classes.dividerLine} />  */}
                            </div>
                            : null}
                        {this.props.stateData.addContactLimitArr[contactType] > 1 ?
                            <SelectedContactComponent
                                contactType={contactType}
                                contactMethodIndex={1}
                                dropdownDiffererentiator={'Two'}
                                onDoneEnabledButton={this.props.onDoneEnabledButton}
                                addContactValueArr={this.props.stateData.addContactValueArr}
                                addContactEncValueArr={this.props.stateData.addContactEncValueArr}
                                onContactMethodCheckHandler={this.props.onContactMethodCheckHandler}
                                addContactCheckedStatusArr={this.props.stateData.addContactCheckedStatusArr}
                                onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                index={this.props.selectedServiceAccount}
                                reloadManageAlertPref={this.props.reloadManageAlertPref}
                                data={this.props.stateData.preferenceData}
                                onSelectDropDown={this.props.onSelectDropDown}
                                showGloabalError={this.props.showGloabalError}
                                showLoadingSpinner={this.props.showLoadingSpinner}
                                hideLoadingSpinner={this.props.hideLoadingSpinner}
                                isDropDownSelectError={this.props.stateData.isDropDownSelectError}
                                isSameValueSelectError={this.props.stateData.isSameValueSelectError}
                                dropDownData={this.props.dropDownData}
                            />
                            : null}
                        {this.props.stateData.addContactLimitArr[contactType] > 2 ?
                            <SelectedContactComponent
                                contactType={contactType}
                                contactMethodIndex={2}
                                dropdownDiffererentiator={'Three'}
                                onDoneEnabledButton={this.props.onDoneEnabledButton}
                                addContactValueArr={this.props.stateData.addContactValueArr}
                                addContactEncValueArr={this.props.stateData.addContactEncValueArr}
                                onContactMethodCheckHandler={this.props.onContactMethodCheckHandler}
                                addContactCheckedStatusArr={this.props.stateData.addContactCheckedStatusArr}
                                onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                index={this.props.selectedServiceAccount}
                                reloadManageAlertPref={this.props.reloadManageAlertPref}
                                data={this.props.stateData.preferenceData}
                                onSelectDropDown={this.props.onSelectDropDown}
                                showGloabalError={this.props.showGloabalError}
                                showLoadingSpinner={this.props.showLoadingSpinner}
                                hideLoadingSpinner={this.props.hideLoadingSpinner}
                                isDropDownSelectError={this.props.stateData.isDropDownSelectError}
                                isSameValueSelectError={this.props.stateData.isSameValueSelectError}
                                dropDownData={this.props.dropDownData}
                            />
                            : null}
                        {!this.props.stateData.addContactToggleStatus[contactType] ?
                            <div className={classes.sceAddButtonContainer + ' row'} >
                                <button
                                    className={this.props.stateData.addContactLimitArr[contactType] === 3 ? classes.sceCPPAddButtonDisabled : classes.sceCPPAddButton} disabled={this.props.stateData.addContactLimitArr[contactType] === 3}
                                    onClick={() => this.props.onAddContactClickHandler(contactType)}>
                                    {(this.props.stateData.addContactLimitArr[contactType] === 3) ? null : <div><img className={classes.addIcon} src={this.addIcon} alt="Add Icon" />
                                    {this.props.addContactButtonText}</div>}
                                </button>
                            </div> : null
                        }
        
                        {(this.props.stateData.addContactToggleStatus[contactType]) ?
                            contactType === 'email' ?
                                <div className={classes.sceTextBoxData}>
                                    <SetUpEmailDropdown
                                        triggerOnClick={() => this.props.onAddContactCancelHandler(contactType)}
                                        onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                        id={contactType}
                                        dropdownDiffererentiator={'Zero'}
                                        index={this.props.index}
                                        reloadManageAlertPref={this.props.reloadManageAlertPref}
                                        data={this.props.data}
                                        premiseData={this.props.premiseData}
                                        onSelectDropDown={(e) => this.props.onSelectDropDown(e)}
                                        showGloabalError={this.props.showGloabalError}
                                        showLoadingSpinner={this.props.showLoadingSpinner}
                                        hideLoadingSpinner={this.props.hideLoadingSpinner}
                                        isDropDownError={this.props.stateData.isAddContactDropDownSelectError[contactType]}
                                        isSameValueError={false}
                                        dropDownData={this.props.dropDownData}
                                        inputButtonText={this.strings.inputAddButtonText}
                                        addContactValueArr={this.props.stateData.addContactValueArr}
                                    />
                                </div>
                                :
                                contactType === 'voice' ?
                                    <div className={classes.sceTextBoxData}>
                                        <SetUpVoiceDropdown
                                            triggerOnClick={() => this.props.onAddContactCancelHandler(contactType)}
                                            onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                            id={contactType}
                                            dropdownDiffererentiator={'Zero'}
                                            index={this.props.index}
                                            reloadManageAlertPref={this.props.reloadManageAlertPref}
                                            data={this.props.data}
                                            premiseData={this.props.premiseData}
                                            onSelectDropDown={(e) => this.props.onSelectDropDown(e)}
                                            showGloabalError={this.props.showGloabalError}
                                            isDropDownError={this.props.stateData.isAddContactDropDownSelectError[contactType]}
                                            isSameValueError={false}
                                            dropDownData={this.props.dropDownData}
                                            inputButtonText={this.strings.inputAddButtonText}
                                            addContactEncValueArr={this.props.stateData.addContactEncValueArr}
                                        />
                                    </div>
                                    :
                                    <div className={classes.sceTextBoxData}>
                                        <SetUpTextDropdown
                                            triggerOnClick={() => this.props.onAddContactCancelHandler(contactType)}
                                            onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                            id={contactType}
                                            dropdownDiffererentiator={'Zero'}
                                            index={this.props.index}
                                            reloadManageAlertPref={this.props.reloadManageAlertPref}
                                            data={this.props.data}
                                            premiseData={this.props.premiseData}
                                            onSelectDropDown={(e) => this.props.onSelectDropDown(e)}
                                            showGloabalError={this.props.showGloabalError}
                                            showLoadingSpinner={this.props.showLoadingSpinner}
                                            hideLoadingSpinner={this.props.hideLoadingSpinner}
                                            isDropDownError={this.props.stateData.isAddContactDropDownSelectError[contactType]}
                                            isSameValueError={false}
                                            dropDownData={this.props.dropDownData}
                                            inputButtonText={this.strings.inputAddButtonText}
                                            addContactEncValueArr={this.props.stateData.addContactEncValueArr}
                                        />
                                    </div>
                            : null}
                            <div className={classes.sceErrorDiv} >
                                <GlobalErrorBlock id={this.props.errorId} errorMessage={!this.props.stateData.isAnyCheckBoxCheckedFlag ? this.strings.isAnyCheckBoxCheckedErrorMsg : null} />
                            </div>
                            </div>
                    </React.Fragment>
                {/* </AccordionComponent> */}
            </div>
        );
    }
}

export default CPPAccordionComponent;
